import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { AuthenticationState } from 'app/shared/authentication/models/login-state.enum';
import { UserVerification } from 'app/shared/authentication/models/user-login.model';
import { ClinicGroupFranchiseSsoInfo } from 'app/shared/clinics/models/clinic-group-franchise-sso-info.model';
import { LoginType } from '../../models/login-type.model';

@Component({
  selector: 'core-auth-authentication-modal',
  templateUrl: './authentication-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class AuthenticationModalComponent {
  @Input() state!: AuthenticationState;
  @Input() authImage?: string;
  @Input() authSentence?: string;
  @Input() authShortName?: string;
  @Output() closeModalEmitter: EventEmitter<any> = new EventEmitter<any>();
  canReturn = false;
  previousCanReturn = false;
  previousState?: AuthenticationState;
  ssoInfo?: ClinicGroupFranchiseSsoInfo;
  userName?: string;
  AuthenticationState = AuthenticationState;
  loginType: LoginType = {
    isUsername: false,
    isSms: false,
    isEmail: false,
    value: '',
  };

  constructor(private ref: ChangeDetectorRef) {}

  switchToLogin(userVerification?: UserVerification): void {
    if (userVerification) {
      this.userName = userVerification.userName;
    }
    this.canReturn =
      this.state === AuthenticationState.ForgotPassword
        ? this.canReturn
        : this.state === AuthenticationState.EmailConfirmation ||
          this.state === AuthenticationState.OneTimeLoginEmail ||
          this.state === AuthenticationState.OneTimeLoginSms;
    this.state = AuthenticationState.LogIn;
    this.ref.markForCheck();
  }

  switchToForgotPassword(): void {
    this.state = AuthenticationState.ForgotPassword;
    this.ref.markForCheck();
  }

  switchToOneTimeLoginEmail(): void {
    this.canReturn = this.state === AuthenticationState.LogIn;
    this.previousState = this.state;
    this.state = AuthenticationState.OneTimeLoginEmail;
    this.ref.markForCheck();
  }

  switchToOneTimeLoginSms(): void {
    this.canReturn = this.state === AuthenticationState.LogIn;
    this.state = AuthenticationState.OneTimeLoginSms;
    this.ref.markForCheck();
  }

  switchToLoginSelection(): void {
    this.state = AuthenticationState.LoginSelection;
    this.ref.markForCheck();
  }

  switchToEmailConfirmation(): void {
    this.previousCanReturn = this.canReturn;
    this.canReturn =
      this.state === AuthenticationState.LoginSelection || this.state === AuthenticationState.LogIn;
    this.previousState = this.state;
    this.state = AuthenticationState.EmailConfirmation;
    this.ref.markForCheck();
  }

  switchToExternalSSO(): void {
    this.state = AuthenticationState.ExternalSSO;
    this.ref.markForCheck();
  }

  setLoginType(loginType: LoginType) {
    this.loginType = loginType;
    this.canReturn = true;
    this.previousCanReturn = false;
    if (!this.loginType.isUsername && this.loginType.isEmail) {
      this.previousState = this.state;
      this.state = AuthenticationState.OneTimeLoginEmail;
      this.ref.markForCheck();
      return;
    }
    if (!this.loginType.isUsername && this.loginType.isSms) {
      this.previousState = this.state;
      this.state = AuthenticationState.OneTimeLoginSms;
      this.ref.markForCheck();
      return;
    }
    this.state = AuthenticationState.LogIn;
    this.ref.markForCheck();
  }

  closeModal(): void {
    this.closeModalEmitter.emit();
  }
}
